import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import counterThemes from "./themes/index.js";
export const CounterBox = styled.div.withConfig({
    displayName: "styled__CounterBox",
    componentId: "sc-ab514dae-0"
})`
	${FlexMixin({
    align: 'center'
})}
`;
export const Label = styled.label.withConfig({
    displayName: "styled__Label",
    componentId: "sc-ab514dae-1"
})`
	padding: 0 12px;
	user-select: none;
	${FontMixin({
    size: 'larger',
    height: 'base',
    weight: 'regular'
})}
	color: ${({ theme  })=>theme.colors.primary.light};

	${({ theme , $hasError  })=>$hasError && `color: ${theme.colors.status.error};`}
	${({ theme  })=>counterThemes[theme.id]?.Label?.()};
`;

//# sourceMappingURL=styled.js.map